import { t } from "i18next"
import * as Yup from "yup"

export const validationFile = Yup.object().shape({
  excelFile: Yup.mixed().required(t("global.you_must_select_a_file", "You must select a file"))
})
export const validationSelectedFields = Yup.object().shape({
  internNumber: Yup.string()
    .nullable()
    .required(t("global.you_must_enter_internnr", "You must enter intern no")),
  regNumber: Yup.string().nullable(),
  mainPropellant: Yup.string()
    .nullable()
    .required(t("global.you_must_enter_fuel_type", "You must specify fuel type")),
  vehicleType: Yup.string(),
  tachographIntegrationActive: Yup.bool(),
  company: Yup.string().nullable().required("Du måste ange bolag")
})
